// FIXME: update to use a const object instead of a typescript enum
// eslint-disable-next-line @bitwarden/platform/no-enums
export enum ClientType {
  Web = "web",
  Browser = "browser",
  Desktop = "desktop",
  // Mobile = "mobile",
  Cli = "cli",
  // DirectoryConnector = "connector",
}
